import copy from "copy-to-clipboard";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";

import { UserContext } from "../contexts";
import { IconName } from "../types";
import Icon from "./Icon";

const FooterShare = observer(() => {
  const userContext = useContext(UserContext);

  const [didCopyToClipboard, setDidCopyToClipboard] = useState(false);

  const getShareUrl = () => {
    return `${window.location.origin}/share-your-home/${userContext.uuid}`;
  };

  const getShareSubject = () => {
    let subject = "I've just priced my new home from Domaine Homes!";
    if (userContext.selectedHome) {
      subject = `I've just priced my new ${userContext.selectedHome.title} home from Domaine Homes!`;
    } else if (userContext.selectedHouseLand) {
      subject = `I've just priced my new ${userContext.selectedHouseLand.house_design} home from Domaine Homes!`;
    }

    return subject;
  };

  const getFacebookShareUrl = () => {
    return (
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(getShareUrl())
    );
  };

  const getEmailShareUrl = () => {
    return `mailto:?subject=${encodeURIComponent(
      getShareSubject()
    )}&body=${encodeURIComponent(getShareUrl())}`;
  };

  const onClickCopyLink = async () => {
    copy(getShareUrl(), {
      message: getShareUrl(),
    });
    setDidCopyToClipboard(true);

    setTimeout(function () {
      setDidCopyToClipboard(false);
    }, 1500);
  };

  const onClickPrint = () => {
    window.print();
  };

  return (
    <div className={"pyht-footer-share container"}>
      <div className={"inner"}>
        <p>Share your home:</p>
        <a
          className={"share-link"}
          href={getFacebookShareUrl()}
          target={"_blank"}
          rel={"noreferrer"}
        >
          <Icon name={IconName.SHARE_FACEBOOK} />
          <span className={"title"}>Facebook</span>
        </a>

        <a
          className={"share-link"}
          href={getEmailShareUrl()}
          target={"_blank"}
          rel={"noreferrer"}
        >
          <Icon name={IconName.SHARE_EMAIL} />
          <span className={"title"}>Email</span>
        </a>

        <div className={"share-link"} onClick={onClickCopyLink}>
          <Icon name={IconName.SHARE_LINK} />
          <span className={"title"}>Copy Link</span>
        </div>
        <div className={"share-link"} onClick={onClickPrint}>
          <Icon name={IconName.SHARE_PDF} />
          <span className={"title"}>Print/Download as PDF</span>
        </div>
      </div>

      {didCopyToClipboard && (
        <div className={"copy-to-clipboard-popover"}>Copied to clipboard!</div>
      )}
    </div>
  );
});

export default FooterShare;
